/**
 * @generated SignedSource<<defb070029cd0c67f0fab86a4f6609b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueTableHideDoneToggle_HideDoneItemsToggle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HideDoneItemsToggle">;
  readonly " $fragmentType": "src_issueTableHideDoneToggle_HideDoneItemsToggle";
};
export type src_issueTableHideDoneToggle_HideDoneItemsToggle$key = {
  readonly " $data"?: src_issueTableHideDoneToggle_HideDoneItemsToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isSavedViewsEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isSavedViewsEnabled",
          "variableName": "isSavedViewsEnabled"
        },
        {
          "kind": "Variable",
          "name": "staticViewInput",
          "variableName": "staticViewInput"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HideDoneItemsToggle"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "2308ca6a9ae8c654cb7cfefd8e7aa49b";

export default node;
